import React from "react";
import { useDispatch } from "react-redux";
import { setModalLoading } from "../../actions/loading";

const Modal = () => {
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(setModalLoading(false));
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <section
        className="modal modal-wide"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <h2>Book a Free Strategic Consultation</h2>
          <button
            className="button button-soft button-sm"
            onClick={() => handleCloseModal()}
          >
            Close
          </button>
        </header>
        <div className="modal-body">
          <iframe
            title="Book a Free Strategic Consultation"
            src="https://calendly.com/hr-lovapextech?hide_gdpr_banner=1&amp;primary_color=078196"
          ></iframe>
          <div className="modal-actions">
            <a
              className="button button-secondary button-md"
              href="https://calendly.com/hr-lovapextech"
              target="_blank"
              rel="noreferrer"
            >
              Open Calendly
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Modal;
